export enum CheckboxColor {
    Blue = 'blue',
    Green = 'green',
    Purple = 'purple',
    Orange = 'orange',
    Red = 'red',
}

export enum CheckboxSize {
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

export enum CheckboxType {
    Check = 'check',
    Cross = 'cross',
}
